import React from 'react';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import StarIcon from './StarIcon';

const useStyles = makeStyles((theme) => ({
  button: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 10,
  },
}));

type RoundButtonProps = IconButtonProps & { favorite: boolean };

const RoundButton = ({ favorite, ...props }: RoundButtonProps) => {
  const classes = useStyles();

  return (
    <IconButton size="small" className={classes.button} {...props}>
      <StarIcon checked={favorite} />
    </IconButton>
  );
};

export default RoundButton;
